import { VOICE_EXTENSION_BY_MIME } from './constants';
import { formatAudioDuration } from '../../utils/audioDuration';

export const formatDuration = formatAudioDuration;

export const buildVoiceFileName = (mimeType) => {
  const extension = VOICE_EXTENSION_BY_MIME[mimeType] || 'webm';
  return `voice-message-${Date.now()}.${extension}`;
};
